import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const getPageIdOfElement = (formConfig: FormConfig | undefined, elementId: string): string | undefined => {
    if (!formConfig) {
        return undefined;
    }

    for (let i = 0; i < formConfig.pages.length; i++) {
        const page = formConfig.pages[i];
        const element = page.elements.find((element) => element.elementId === elementId);
        if (element) {
            return page.pageId;
        }
    }

    return undefined;
};
